export const colorsArr = {
	black: {
		bgColor: 'bg-dark',
		iconColor: 'text-dark',
		iconBgColor: 'bg-800',
		colorName: 'Dark Mode',
		iconHexColor: '#FFFFFF',
		bgHexColor: '#191C29',
	},
	white: {
		bgColor: 'bg-white',
		iconColor: 'text-700',
		iconBgColor: 'bg-50',
		colorName: 'Light Mode',
		iconHexColor: '#191C29',
		bgHexColor: '#FFFFFF',
	},
	gray: {
		bgColor: 'bg-gray',
		iconColor: 'text-secondary',
		iconBgColor: 'bg-secondary',
		colorName: 'Gray',
		iconHexColor: '#75777F',
		bgHexColor: '#E5E7EB',
	},
	pink: {
		bgColor: 'bg-pink',
		iconColor: 'text-pink-700',
		iconBgColor: 'bg-pink-100',
		colorName: 'Pink',
		iconHexColor: '#E043B1',
		bgHexColor: '#FCE4F4',
	},
	blue: {
		bgColor: 'bg-primary',
		iconColor: 'text-blue-600',
		iconBgColor: 'bg-blue-100',
		colorName: 'Blue',
		iconHexColor: '#1571F0',
		bgHexColor: '#E1ECFB',
	},
	green: {
		bgColor: 'bg-green',
		iconColor: 'text-green-800',
		iconBgColor: 'bg-green-100',
		colorName: 'Green',
		iconHexColor: '#198754',
		bgHexColor: '#DFF5EA',
	},
	red: {
		bgColor: 'bg-red',
		iconColor: 'text-red-500',
		iconBgColor: 'bg-red-100',
		colorName: 'Red',
		iconHexColor: '#DC3545',
		bgHexColor: '#FDE8EA',
	},
	yellow: {
		bgColor: 'bg-yellow',
		iconColor: 'text-yellow-900',
		iconBgColor: 'bg-yellow-200',
		colorName: 'Yellow',
		iconHexColor: '#FFC107',
		bgHexColor: '#FFF8E1',
	},
	orange: {
		bgColor: 'bg-orange',
		iconColor: 'text-orange-800',
		iconBgColor: 'bg-orange-200',
		colorName: 'Orange',
		iconHexColor: '#FD7E14',
		bgHexColor: '#FFF3E0',
	},
	cyan: {
		bgColor: 'bg-cyan',
		iconColor: 'text-cyan-800',
		iconBgColor: 'bg-cyan-100',
		colorName: 'Cyan',
		iconHexColor: '#0DCAF0',
		bgHexColor: '#E0FBFF',
	},
	indigo: {
		bgColor: 'bg-indigo',
		iconColor: 'text-indigo-600',
		iconBgColor: 'bg-indigo-100',
		colorName: 'Indigo',
		iconHexColor: '#0D4899',
		bgHexColor: '#E3EAF9',
	},
	purple: {
		bgColor: 'bg-purple',
		iconColor: 'text-purple-600',
		iconBgColor: 'bg-purple-100',
		colorName: 'Purple',
		iconHexColor: '#6610F2',
		bgHexColor: '#EFE7FD',
	},
	teal: {
		bgColor: 'bg-teal',
		iconColor: 'text-teal-800',
		iconBgColor: 'bg-teal-200',
		colorName: 'Teal',
		iconHexColor: '#20C997',
		bgHexColor: '#E0F9F3',
	},
};

export const launchpadCustomizationDefaultState = {
	'widget-header': {
		iconColor: '',
		iconBgColor: '',
		linkColor: '',
		headerImage: '',
		headerTitle: 'Launchpad',
		headerTitleDescription:
			'Your central hub to help you discover the best features and get the most out of Back At You!',
	},
	'widget-header-action': {
		iconColor: '',
		iconBgColor: '',
		linkColor: '',
	},
	'widget-marketing': {
		iconColor: '#dc3545',
		iconBgColor: '#FFECE6',
		linkColor: '#0d6efd',
		headerTitle: 'Marketing',
		headerIcon: {
			name: 'BsMegaphone',
			label: 'megaphone',
			Icon: 'BsMegaphone',
		},
		sections: [
			{
				id: 'socialMedia',
				header: 'Social Media',
				description: 'Brand exposure & lead gen.',
				options: [
					{
						title: 'Social Media Marketing Shortcuts',
						links: [
							{
								key: 'scheduledContent',
								label: 'My Scheduled Content',
								path: '/content-calendar',
								isVisible: true,
							},
							{
								key: 'promoteListing',
								label: 'Promote a Listing',
								path: '/listings',
								isVisible: true,
							},
							{
								key: 'schedulePost',
								label: 'Schedule a Post',
								path: '#/myCreator',
								isVisible: true,
							},
						],
					},
					{
						title: 'Social Media Content by Category',
						designStudio: 'DESIGN STUDIO',
						links: [
							{
								key: 'allSocialContent',
								label: 'All Social Content Templates',
								path: '/project/choose-template',
								isVisible: true,
							},
							{
								key: 'leadGenContent',
								label: 'Content for Lead Generation',
								path: '/project/choose-template?templateCategory=Lead%20Generation',
								isVisible: true,
							},
							{
								key: 'listingContent',
								label: 'Content for Listings',
								path: '/project/choose-template?templateCategory=Listing%20Marketing',
								isVisible: true,
							},
							{
								key: 'holidaysTemplates',
								label: 'Templates for Holidays',
								path: '/project/choose-template?templateCategory=Holidays',
								isVisible: false,
							},
							{
								key: 'agentPromotionTemplates',
								label: 'Templates for Agent Promotion',
								path: '/project/choose-template?templateCategory=Agent%20Promotion',
								isVisible: false,
							},
						],
					},
				],
			},
			{
				id: 'email',
				header: 'Email',
				description: 'Drip campaigns & email blasts.',
				options: [
					{
						title: 'Email Marketing Shortcuts',
						links: [
							{
								key: 'createCampaign',
								label: 'Create a Campaign',
								path: '/?page=mycampaigns#open_campaign_wizard=true',
								isVisible: true,
							},
							{
								key: 'campaignAnalytics',
								label: 'My Campaign Analytics',
								path: '/?page=mycampaigns',
								isVisible: true,
							},
						],
					},
					{
						title: 'Email Marketing Templates',
						links: [
							{
								key: 'allTemplates',
								label: 'All Email Templates',
								path: '/?page=content&cat=personal&category=#select_template=true',
								isVisible: true,
							},
							{
								key: 'listingTemplates',
								label: 'Listing Email Templates',
								path: '/?page=content&cat=personal&category=Eblast#select_template=true',
								isVisible: true,
							},
							{
								key: 'holidayTemplates',
								label: 'Holiday Email Templates',
								path: '/?page=content&cat=personal&category=Holiday#select_template=true',
								isVisible: true,
							},
							{
								key: 'newsletterTemplates',
								label: 'Newsletter Email Templates',
								path: '/?page=content&cat=personal&category=Newsletters#select_template=true',
								isVisible: true,
							},
							{
								key: 'eventEmailTemplates',
								label: 'Event Email Templates',
								path: '/?page=content&cat=personal&category=Event#select_template=true',
								isVisible: false,
							},
						],
					},
				],
			},
			{
				id: 'print',
				header: 'Print',
				description: 'Postcards, flyers & more!',
				options: [
					{
						title: 'Print Marketing Shortcuts',
						links: [
							{
								key: 'orderPostcards',
								label: 'Order Postcards',
								path: '/project/choose-template?secondaryKeys=Layout:Landscape,Format:Postcard',
								isVisible: true,
							},
							{
								key: 'createFlyers',
								label: 'Create Flyers',
								path: '/project/choose-template?secondaryKeys=Layout:Portrait,Format:Flyer',
								isVisible: true,
							},
							{
								key: 'myOrders',
								label: 'My Orders',
								path: '/orders',
								isVisible: true,
							},
						],
					},
					{
						title: 'Print Marketing Content Templates',
						designStudio: 'DESIGN STUDIO',
						links: [
							{
								key: 'allPostcardTemplates',
								label: 'All Postcard Templates',
								path: '/project/choose-template?secondaryKeys=Layout:Landscape,Format:Postcard',
								isVisible: true,
							},
							{
								key: 'allFlyerContentTemplates',
								label: 'All Flyer Content Templates',
								path: '/project/choose-template?secondaryKeys=Layout:Portrait,Format:Flyer',
								isVisible: true,
							},
							{
								key: 'listingPostcardTemplates',
								label: 'Listing Postcard Templates',
								path: '/project/choose-template?templateCategory=Listing%20Marketing&secondaryKeys=Layout:Landscape,Format:Postcard',
								isVisible: true,
							},
							{
								key: 'listingFlyerTemplates',
								label: 'Listing Flyer Templates',
								path: '/project/choose-template?templateCategory=Listing%20Marketing&secondaryKeys=Layout:Portrait,Format:Flyer',
								isVisible: false,
							},
							{
								key: 'holidayPostcardTemplates',
								label: 'Holiday Postcard Templates',
								path: '/project/choose-template?templateCategory=Holidays',
								isVisible: false,
							},
							{
								key: 'marketingUpdatePostcardTemplates',
								label: 'Marketing Update Postcard Templates',
								path: '/project/choose-template?templateCategory=Market%20Updates',
								isVisible: false,
							},
						],
					},
				],
			},
		],
		allowWidgetCustomization: true,
	},
	'widget-banner': {
		bannerImage:
			'https://bay.cdn.backatyou.com/ui/placeholders/BAY_DesignStudio.jpg',
		bannerHoverText: 'View',
		bannerHoverUrl: 'https://www.link.com',
		bannerTextColor: '#1571F0',
	},
	'widget-crm': {
		iconColor: '#520DC2',
		iconBgColor: '#E0CFFC',
		linkColor: '#0d6efd',
		headerTitle: 'CRM',
		headerTitleDescription: 'Nurture your contacts & leads!',
		headerIcon: {
			name: 'BsPeople',
			label: 'people',
			Icon: 'BsPeople',
		},
		links: [
			{
				id: 'addNewContact',
				label: 'Add a New Contact',
				path: '/?page=contacts#add_contact=true', // Query param to open contact modal
				isVisible: true,
			},
			{
				id: 'manageContacts',
				label: 'Manage Contacts & Leads',
				path: '/?page=contacts',
				isVisible: true,
			},
			{
				id: 'createTask',
				label: 'Create a Task',
				path: '/?page=dashboard#add_task=true', // Query param to open task modal
				isVisible: true,
			},
			{
				id: 'manageActionPlans',
				label: 'Manage Action Plans',
				path: '/?page=myactionplans',
				isVisible: true,
			},
			{
				id: 'manageContactTags',
				label: 'Manage Contact Tags',
				path: '/?page=contacts#manage_tags=true',
				isVisible: true,
			},
			{
				id: 'crmDashboard',
				label: 'CRM Dashboard',
				path: '/?page=dashboard',
				isVisible: false,
			},
			{
				id: 'manageCustomFields',
				label: 'Manage Custom Fields',
				path: '/?page=contacts#manage_custom_fields=true',
				isVisible: false,
			},
			{
				id: 'manageContactSharing',
				label: 'Manage Contact Sharing',
				path: '/?page=contacts-sharing',
				isVisible: false,
			},
			{
				id: 'importContacts',
				label: 'Import Contacts',
				path: '/?page=contacts#import_contacts=true',
				isVisible: false,
			},
		],
		allowWidgetCustomization: true,
	},
	'widget-listings': {
		iconColor: '#115AC0',
		iconBgColor: '#D0E3FC',
		linkColor: '#0d6efd',
		headerTitle: 'Listings',
		headerTitleDescription: 'Take action with your listings.',
		headerIcon: {
			name: 'BsHouse',
			label: 'house',
			Icon: 'BsHouse',
		},
		links: [
			{
				id: 'viewListings',
				label: 'View Listings',
				path: '/?page=listings',
				isVisible: true,
			},
			{
				id: 'addListing',
				label: 'Add a Listing',
				path: '/?page=listings#add_listing=true',
				isVisible: true,
			},
			{
				id: 'scheduleOpenHouse',
				label: 'Schedule an Open House',
				path: '/?page=openhouses#add_openhouse=true',
				isVisible: true,
			},
			{
				id: 'addOpenHouseOpportunity',
				label: 'Add Open House Opportunity', // TAB WORK THERE
				path: '/?page=openhouses',
				isVisible: true,
			},
		],
		allowWidgetCustomization: true,
	},
	'widget-websites': {
		iconColor: '#332701',
		iconBgColor: '#FFF3CD',
		linkColor: '#0d6efd',
		headerTitle: 'Websites',
		headerTitleDescription: 'Monitor & edit your websites.',
		headerIcon: {
			name: 'BsGlobe',
			label: 'globe',
			Icon: 'BsGlobe',
		},
		links: [
			{
				id: 'viewWebsites',
				label: 'View Websites',
				isVisible: true,
			},
			{
				id: 'addTestimonials',
				label: 'Add Testimonials',
				path: '/?page=testimonials#add_testimonial=true',
				isVisible: true,
			},
			{
				id: 'manageBlogPosts',
				label: 'Manage Blogs & Posts',
				path: '/?page=blogs',
				isVisible: true,
			},
		],
		allowWidgetCustomization: true,
	},
	'widget-financial': {
		iconColor: '#0A3622',
		iconBgColor: '#D1E7DD',
		linkColor: '#0d6efd',
		headerTitle: 'Financial',
		headerTitleDescription: 'Transactions,eSign documents & more!',
		headerIcon: {
			name: 'BsCash',
			label: 'cash',
			Icon: 'BsCash',
		},
		links: [
			{
				id: 'myTransactions',
				label: 'My Transactions',
				path: '/?page=Agents_Transactions',
				isVisible: true,
			},
			{
				id: 'addListingTransaction',
				label: 'Add Listing Transaction',
				path: '/?page=Agents_Transactions#add_listing_transaction=true',
				isVisible: true,
			},
			{
				id: 'addBuyerTenantTransaction',
				label: 'Add Buyer/Tenant Transaction',
				path: '/?page=Agents_Transactions#add_buyer_tenant_transaction=true',
				isVisible: true,
			},
			{
				id: 'addOfferTransaction',
				label: 'Add Offer Transaction',
				path: '/?page=Agents_Transactions#add_offer_transaction=true',
				isVisible: true,
			},
			{
				id: 'createEsign',
				label: 'Create eSign Packet',
				path: '/?page=esign#add_esign_packet=true',
				isVisible: true,
			},
		],
		allowWidgetCustomization: true,
	},
	'widget-otherLinks': {
		linkColor: '#0d6efd',
		sections: {
			firstTabLinks: {
				showSection: false,
				sectionTitle: 'Other Links',
				options: [
					{
						id: 'optionalLink1',
						label: 'Example Link',
						path: 'https://www.link.com',
						isVisible: true,
					},
					{
						id: 'optionalLink2',
						label: 'Example Link',
						path: 'https://www.link.com',
						isVisible: true,
					},
					{
						id: 'optionalLink3',
						label: 'Example Link',
						path: 'https://www.link.com',
						isVisible: true,
					},
				],
			},
			secondTabLinks: {
				sectionTitle: 'Account',
				options: [
					{
						id: 'myProfile',
						label: 'My Profile',
						path: '#profile_slide=true',
						isVisible: true,
					},
				],
			},
			thirdTabLinks: {
				showSection: false,
				sectionTitle: 'Resources',
				options: [
					{
						id: 'getHelp',
						label: 'Get Help',
						path: '#help_center=true',
						isVisible: true,
					},
					{
						id: 'productUpdates',
						label: 'Product Updates',
						path: '#product_updates=true',
						isVisible: true,
					},
					{
						id: 'registerTraining',
						label: 'Register for Training',
						path: 'https://tcbackatyou.trainercentralsite.com/#/allsessions',
						isVisible: true,
					},
					{
						id: 'facebookGroup',
						label: 'Facebook Mastermind Group',
						path: 'https://www.facebook.com/groups/210001779372182/',
						isVisible: true,
					},
				],
			},
		},
	},
	'widget-adsAndLeads': {
		iconColor: '#520DC2',
		iconBgColor: '#E0CFFC',
		linkColor: '#0d6efd',
		headerTitle: 'Ads & Leads',
		headerTitleDescription: 'Track ad performance & manage your leads!',
		headerIcon: {
			name: 'BsPeople',
			label: 'people',
			Icon: 'BsPeople',
		},
		links: [
			{
				id: 'advertisingAnalytics',
				label: 'Advertising Analytics',
				path: '/analytics/content',
				isVisible: true,
			},
			{
				id: 'myLeads',
				label: 'My Leads',
				path: '/leads',
				isVisible: true,
			},
		],
		allowWidgetCustomization: true,
	},
	'widget-listingsSmc': {
		iconColor: '#115AC0',
		iconBgColor: '#D0E3FC',
		linkColor: '#0d6efd',
		headerTitle: 'Listings',
		headerTitleDescription: 'Take action with your listings.',
		headerIcon: {
			name: 'BsHouse',
			label: 'house',
			Icon: 'BsHouse',
		},
		links: [
			{
				id: 'viewListings',
				label: 'View Listings',
				path: '/listings',
				isVisible: true,
			},
			{
				id: 'scheduleOpenHouse',
				label: 'Schedule an Open House',
				path: '/listings',
				isVisible: true,
			},
		],
		allowWidgetCustomization: true,
	},
	'widget-landingPages': {
		iconColor: '#332701',
		iconBgColor: '#FFF3CD',
		linkColor: '#0d6efd',
		headerTitle: 'Landing Pages',
		headerTitleDescription: 'Monitor & edit your landing pages.',
		headerIcon: {
			name: 'BsGlobe',
			label: 'globe',
			Icon: 'BsGlobe',
		},
		links: [
			{
				id: 'homeValueLandingPages',
				label: 'Home Value Landing Pages',
				path: '/landing-pages/library/type=home-valuation',
				isVisible: true,
			},
			{
				id: 'contactLandingPages',
				label: 'Contact Landing Pages',
				path: '/landing-pages/library/type=contact-form',
				isVisible: true,
			},
			{
				id: 'downloadableGuideLandingPages',
				label: 'Downloadable Guide Landing Pages',
				path: '/landing-pages/library/type=downloadable-guide',
				isVisible: true,
			},
		],
		allowWidgetCustomization: true,
	},
};

export const defaultWidgetConfig = [
	{
		id: 'widget-header',
		dims: { h: 1.3, w: 3 },
		coords: { x: 0, y: 0 },
		minW: 3,
		maxW: 3,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Header',
	},
	{
		id: 'widget-header-action',
		dims: { h: 1.3, w: 2 },
		coords: { x: 6, y: 0 },
		minW: 2,
		maxW: 2,
		theme: null,
		isForAdmin: false,
		editModalTitle: '',
	},
	{
		id: 'widget-marketing',
		dims: { h: 4.2, w: 3 },
		coords: { x: 0, y: 1 },
		minW: 3,
		maxW: 3,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-banner',
		dims: { h: 4.2, w: 1 },
		coords: { x: 3, y: 1 },
		minW: 1,
		maxW: 1,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Image Widget  ',
	},
	{
		id: 'widget-otherLinks',
		dims: { h: 7.7, w: 1 },
		coords: { x: 4, y: 1 },
		minW: 1,
		maxW: 1,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-crm',
		dims: { h: 3.5, w: 1 },
		coords: { x: 0, y: 5 },
		minW: 1,
		maxW: 1,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-listings',
		dims: { h: 3.5, w: 1 },
		coords: { x: 1, y: 5 },
		minW: 1,
		maxW: 1,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-websites',
		dims: { h: 3.5, w: 1 },
		coords: { x: 2, y: 5 },
		minW: 1,
		maxW: 1,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-financial',
		dims: { h: 3.5, w: 1 },
		coords: { x: 3, y: 5 },
		minW: 1,
		maxW: 1,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-adsAndLeads',
		dims: { h: 3.5, w: 1.33 },
		coords: { x: 0, y: 5 },
		minW: 1,
		maxW: 1,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-listingsSmc',
		dims: { h: 3.5, w: 1.33 },
		coords: { x: 1.33, y: 5 },
		minW: 1,
		maxW: 1,
		theme: null,
		isForAdmin: false,
		editModalTitle: 'Edit Widget',
	},
	{
		id: 'widget-landingPages',
		dims: { h: 3.5, w: 1.33 },
		coords: { x: 2.66, y: 5 },
		minW: 1,
		maxW: 1,
		editModalTitle: 'Edit Widget',
	},
];
